<template>
  <div class="manual-container">
    <p class="component-title">{{ $t('PEER.ScoringStandard.title') }}</p>
    <p class="text-danger">{{ $t('PEER.ScoringStandard.explanation') }}</p>
    <TabulatorComponent v-model="data" :options="options" />

    <div class="button-wrapper">
      <button
        @click="
          () => {
            AC_INIT_PAPER();
          }
        "
      >
        {{ $t('PEER.ScoringStandard.initialize') }}
      </button>
      <button
        @click="
          () => {
            moveNextStep();
          }
        "
      >
        {{ $t('PEER.ScoringStandard.next') }}
      </button>
    </div>
  </div>
</template>

<script>
import { TabulatorComponent } from 'vue-tabulator';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ScoringStandard',
  components: {
    TabulatorComponent,
  },
  data() {
    return {
      data: [],
      options: {
        columns: [],
      },
      tableData: [],
    };
  },
  methods: {
    ...mapActions('peerPaper', [
      'AC_MOVE_NEXT_EVALUTATION_STEP',
      'AC_SET_SCORING_METHOD',
      'AC_SET_MAX_SCORE',
      'AC_SET_FEEDBACK_STATUS',
      'AC_SET_FEEDBACK_QUESTION',
      'AC_SET_SCORE_CARD',
      'AC_INIT_PAPER',
    ]),
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    setTableData(cell, column) {
      const targetClass = cell.target.className;
      const targetIndex = targetClass.split('-')[1];

      let cellData;
      const func = (event) => {
        switch (column) {
          case '채점방법':
            cellData = event.target.value;
            this.AC_SET_SCORING_METHOD({
              index: targetIndex,
              value: cellData,
            });
            break;
          case '최대 점수':
            cellData = event.target.value;
            this.AC_SET_MAX_SCORE({
              index: targetIndex,
              value: cellData,
            });
            break;
          case '피드백':
            cellData = event.target.value === '있음' ? true : false;
            this.AC_SET_FEEDBACK_STATUS({
              index: targetIndex,
              value: cellData,
            });
            document.querySelector(`.feedbackQuestion-${targetIndex}`).value = '';
            document.querySelector(`.feedbackQuestion-${targetIndex}`).disabled = !cellData;
            break;
          case '피드백 질문':
            cellData = event.target.value;
            this.AC_SET_FEEDBACK_QUESTION({
              index: targetIndex,
              value: cellData,
            });
            break;
          case '채점표':
            cellData = event.target.files[0];
            this.AC_SET_SCORE_CARD({
              index: targetIndex,
              file: cellData,
            });
            break;
          default:
            cellData = event.target.value;
            break;
        }

        this.tableData[targetIndex][column] = cellData;
      };

      document.querySelector(`.${cell.target.className}`).addEventListener('change', func);
      document.removeEventListener('change', func);
    },
    setColumns() {
      const columnsList = ['채점방법', '최대 점수', '피드백', '피드백 질문', '채점표'];
      const columnSetting = [
        {
          title: '문항번호',
          field: '문항번호',
          width: `10%`,
          editor: false,
          headerSort: false,
        },
      ];

      columnsList.forEach((colName) => {
        columnSetting.push({
          title: colName,
          field: colName,
          formatter: 'html',
          width: (colName === '최대 점수') | (colName === '피드백') ? '15%' : '20%',
          editor: false,
          headerSort: false,
          cellClick: (cell) => {
            this.setTableData(cell, colName);
          },
        });
      });

      this.options.columns = columnSetting;
    },
    moveNextStep() {
      const checkForm = this.tableData.reduce((sum, currentValue) => {
        if (
          currentValue['채점방법'] === '' ||
          (currentValue['피드백'] && currentValue['피드백 질문'] === '')
        ) {
          return sum;
        } else {
          return sum + 1;
        }
      }, 0);

      if (checkForm === this.tableData.length) {
        this.AC_MOVE_NEXT_EVALUTATION_STEP();
      } else {
        const content =
          this.$i18n.locale === 'eng'
            ? `You haven't finished setting up your evaluation sheet.`
            : '평가지 설정이 완료되지 않았습니다.';
        const url = '';
        this.AC_MODAL_OPEN({
          content: content,
          url: url,
        });
      }
    },
  },
  computed: {
    ...mapGetters('peerPaper', ['GE_PAPER_QUESTIONS']),
  },
  created() {
    this.setColumns();

    const colArr = this.GE_PAPER_QUESTIONS;
    colArr.forEach((col, index) => {
      const form = {
        문항번호: col,
        채점방법: `<textarea class="description-${index}" style="resize: none;"rows='3' cols='20'/>`,
        '최대 점수': `<select class="maxScore-${index}" >\
        <option>2</option>\
        <option>3</option>\
        <option>4</option>\
        <option>5</option>\
        </select>`,
        피드백: `<select class="feedback-${index}" >\
        <option>있음</option>\
        <option>없음</option>\
        </select>`,
        '피드백 질문': `<textarea class="feedbackQuestion-${index}" style="resize: none;"rows='3' cols='20'/>`,
        채점표: `<input type="file" accept=".jpg, .jpeg, .png" class="fileInput-${index}" />`,
      };
      const tableForm = {
        문항번호: col,
        채점방법: '',
        '최대 점수': 2,
        피드백: false,
        '피드백 질문': '',
        채점표: null,
      };
      this.data.push(form);
      this.tableData.push(tableForm);

      this.options.columns[0].title = this.$i18n.locale === 'eng' ? 'Index' : '문항번호';
      this.options.columns[1].title = this.$i18n.locale === 'eng' ? 'Grading Methods' : '채점방법';
      this.options.columns[2].title = this.$i18n.locale === 'eng' ? 'Maximum score' : '최대 점수';
      this.options.columns[3].title = this.$i18n.locale === 'eng' ? 'Feedback' : '피드백';
      this.options.columns[4].title =
        this.$i18n.locale === 'eng' ? 'Feedback Question' : '피드백 질문';
      this.options.columns[5].title = this.$i18n.locale === 'eng' ? 'Grading table' : '채점표';
    });
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.options.columns[0].title = newLocale === 'eng' ? 'Index' : '문항번호';
      this.options.columns[1].title = newLocale === 'eng' ? 'Grading Methods' : '채점방법';
      this.options.columns[2].title = newLocale === 'eng' ? 'Maximum score' : '최대 점수';
      this.options.columns[3].title = newLocale === 'eng' ? 'Feedback' : '피드백';
      this.options.columns[4].title = newLocale === 'eng' ? 'Feedback Question' : '피드백 질문';
      this.options.columns[5].title = newLocale === 'eng' ? 'Grading table' : '채점표';
    },
  },
};
</script>

<style lang="scss" scoped></style>
